import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import './CustomRangePicker.css';  // Importando o CSS

const { RangePicker } = DatePicker;

const CustomRangePicker = ({ setDataInicio, setDataFim, value }) => {
  const pickerValue =
    value?.dataInicio && value?.dataFim
      ? [moment(value.dataInicio, "YYYY-MM-DD"), moment(value.dataFim, "YYYY-MM-DD")]
      : null;

  return (
    <div className="d-flex col-7 col-md-auto">
      <RangePicker
        value={pickerValue}
        style={{
          width: '100%', // Faz o RangePicker ocupar 100% da largura
        }}
        placeholder={["Data Inicial", "Data Final"]}
        onChange={(dates, dateStrings) => {
          setDataInicio(dateStrings ? dateStrings[0] : null);
          setDataFim(dateStrings ? dateStrings[1] : null);
        }}
      />
    </div>
  );
};

export default CustomRangePicker;
